import React from 'react';
import PropTypes from 'prop-types';
import ShowConditionsButtonComponent from '@Components/Results/reactions/reaction-details/show-conditions-button.component';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ShowMoreComponent from '@Components/Results/utils/show-more.component';
import ReactReactionAdditionalInfoHelper from '@Components/Results/services/react-reaction-additional-info-helper.service';
import ReactionDetailRowComponent from '@Components/Results/reactions/reaction-details/reaction-detail-row.component';
/* eslint-disable react/destructuring-assignment */
export default class ReactionDetailsTableComponent extends React.Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.isCIDatabase = ReactReactionAdditionalInfoHelper.isCIDatabase(this.props.databaseId);
    this.containerClass = this.props.isHitDetails ? 'reaction-hit-details' : 'reaction-details';
  }

  componentDidMount() {
    if (!this.props.isHitDetails && this.props.hasHitDetails) {
      this.tableRef.current.scrollTo({ top: this.tableRef.current.scrollHeight, behavior: 'smooth' });
    }
  }

  render() {
    const { metadata } = this.props;
    const allowShowMore = !metadata.isViewPreview || this.props.isHitDetails;
    const rows = this.props.details.map((detail, index) => (
      <ReactionDetailRowComponent
        metadata={metadata}
        /* eslint-disable-next-line react/no-array-index-key */
        key={index}
        detail={detail}
        index={this.props.index}
        reactionId={this.props.reactionId}
        isHit={this.props.isHitDetails || detail.isHit}
        spinnerId={this.props.spinnerId}
        databaseId={this.props.databaseId}
        largestProduct={this.props.largestProduct}
      />
    ));

    return (
      <table
        ref={this.tableRef}
        id={`${this.containerClass}-${this.props.index}`}
        className="rx-reactions-table rx-table--full-width rx-table--full-height display-table c-els-table c-els-table--middle c-els-table--vertical-dividers c-els-table--subtle-dividers">
        <thead className="c-els-table__head">
          <tr className="c-els-table__row c-els-table__row--head c-els-table__row--sticky">
            <th className="rx-reactions-table__conditions c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
              Conditions
            </th>
            <th className="rx-reactions-table__yield  c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">Yield</th>
            <th className="rx-reactions-table__references u-els-display-none@tablet c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
              {this.isCIDatabase ? 'Reference/Experiment' : 'Reference'}
            </th>
          </tr>
        </thead>
        <tbody className="c-els-table__body">
          {rows}
          {this.props.displayFooter && this.props.initialDetailsNumber < this.props.detailsCount && (
            <tr className="c-els-table__row">
              <td className="c-els-table__cell c-els-table__basic-cell" colSpan="4">
                <div className="rx-table__caption rx-btn-group--center">
                  {allowShowMore && (
                    <ShowMoreComponent
                      labelAll={`Show all ${this.props.isHitDetails ? 'hits' : 'conditions'}`}
                      initial={this.props.initialDetailsNumber}
                      current={this.props.details.length}
                      total={this.props.detailsCount}
                      container={`#${this.containerClass}-${this.props.index}`}
                      scrollToLess={`#${this.containerClass}-${this.props.index}`}
                      moreHandler={this.props.showMoreHandler}
                      lessHandler={this.props.showLessHandler}
                    />
                  )}
                  {allowShowMore && this.props.showNextConditions && (
                    <ShowConditionsButtonComponent
                      toggleAllDetails={this.props.toggleAllDetails}
                      showNextConditions={this.props.showNextConditions}
                      index={this.props.index}
                    />
                  )}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
}

ReactionDetailsTableComponent.defaultProps = {
  displayFooter: true,
};

ReactionDetailsTableComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  reactionId: PropTypes.string.isRequired,
  details: PropTypes.array.isRequired,
  detailsCount: PropTypes.number.isRequired,
  initialDetailsNumber: PropTypes.number,
  isHitDetails: PropTypes.bool,
  hasHitDetails: PropTypes.bool,
  spinnerId: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  showMoreHandler: PropTypes.func.isRequired,
  showLessHandler: PropTypes.func.isRequired,
  showNextConditions: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  toggleAllDetails: PropTypes.func,
  databaseId: PropTypes.string.isRequired,
  displayFooter: PropTypes.bool,
  largestProduct: PropTypes.string,
};
